<script>
import {defineComponent} from 'vue'
import {getcontact, goodsPai} from "../api/api";
import {mapGetters} from "vuex";
import headNav from "../components/headNav.vue";
import router from "../router";

export default defineComponent({
  name: "contact",
  computed:{
    ...mapGetters(['userInfo'])
  },
  components:{headNav},
  data(){
    return{
      name:'',
      email:'',
      message:'',
      dataArr:[],
      dataObj:{}
    }
  },
  created() {
    this.getList()
  },
  methods:{
    go(name,e){
      router.push(
        {
          name,
          query:{
            id:e
          }
        }
      )
    },
    getList() {
      goodsPai({}).then(res => {
        console.log(res,'打印res111')
        this.dataArr = res.data.data.data
        this.dataObj = res.data.data.title
		
        console.log(this.dataArr,'打印数组')
		console.log(this.dataObj,'打印数组999')
      })
    },
    submit(){
      getcontact({
        name:this.name,
        msg: this.message,
        id: this.userInfo.id,
        email: this.email
      }).then(res => {
        console.log(res,'打印res')
        if(res.data.status == 200){
          this.$message({
            message: res.data.message,
            type:'success'
          });
          setTimeout(() => {
            this.name = ''
            this.email = ''
            this.message = ''
          },1000)
        }else {
          this.$message({
            message: res.data.message,
            type:'warning'
          });
        }
      })
    }
  }
})
</script>

<template>
  <div class="withoutBOX">


<!--    <section id="intro" class="bg-light padding-large">-->
<!--      <div class="container">-->
<!--        <div class="row">-->
<!--          <div class="col-xl-8 offset-xl-2 col-lg-10 offset-lg-1">-->

<!--            <div class="page-title text-center">-->
<!--              <h2>Shop</h2>-->
<!--              <div class="breadcum-items">-->
<!--                <span class="item"><a href="index.html">Home /</a></span>-->
<!--                <span class="item colored">Shop</span>-->
<!--              </div>-->
<!--            </div>-->

<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->
    <div class="headfont">
      <div class="heart">
        拍卖日程
      </div>


    </div>
    <div class="contentBox heart">
      <aside class="col-md-3 ">
        <div class="mesBox ">
          <div class="title">
            {{dataObj.title}}
          </div>
          <div class="text" v-html="dataObj.des">

          </div>
        </div>
      </aside>
      <div >
        <div class="container">
          <div class="row">
            <main class="col-md-9" >

              <div v-for="(item,index) in dataObj.times" :key="index" class="col-md-9_detail" style="width: 300px;"  @click="go('changciDetail',item.id)">
                <div class="filter-shop d-flex align-items-center justify-content-between pb-3" >
                  <div class="showing-product">
                    <!-- <p class="no-margin-bottom" style="margin-top: 20px;font-weight: bold">{{item.date.split(' ')[0]}}</p> -->
                  </div>
                </div>
                <div class="product-content product-store d-flex flex-wrap">
                  <!-- <div class="col-lg-6 col-md-6" style="position: relative" v-for="(e,index2) in item.list" :key="index2" @click="go('changciDetail',e)"> -->
                    <!-- <div class="status1" v-if="item.status == 1"> -->
                      <!-- 等待预展 -->
                    <!-- </div><div class="status1" v-if="item.status == 2"> -->
                    <!-- 预展中 -->
                  <!-- </div><div class="status1" v-if="item.status == 3"> -->
                    <!-- 待拍卖 -->
                  <!-- </div><div class="status1" v-if="item.status == 4"> -->
                    <!-- 拍卖中 -->
                  <!-- </div><div class="status1" v-if="item.status == 5"> -->
                    <!-- 拍卖结束 -->
                  <!-- </div> -->
                    <div class="product-card link-effect pe-3 pb-3">
                      <figure class="zoom-effect">
                        <div  class="zoom-in"><img :src="item.image" alt="stories" class="lgpostImg img-fluid" ></div>
                      </figure>
					  <span class="text">{{item.sku}}</span>
                      <div class="story-title-wrap d-flex justify-content-between">
                        <h5 >{{item.title}}</h5>
                      </div>
                      <div class="wenzi">
                        <span class="text">{{item.describe}}</span>
                        <span class="text">拍卖地点：{{item.address}}</span>
                        <span class="text">拍卖时间：{{item.pai_time}}</span>
                      </div>
                    </div>
                  <!-- </div> -->
                </div>
              </div>
              <!--            <nav class="navigation paging-navigation text-center padding-medium no-padding-top" role="navigation">-->
              <!--              <div class="pagination loop-pagination d-flex justify-content-center align-items-center">-->
              <!--                <a href="#" class="pe-3">-->
              <!--                  <svg class="bi" width="30" height="30"><use xlink:href="#long-arrow-alt-left"></use></svg>-->
              <!--                </a>-->
              <!--                <span aria-current="page" class="page-numbers current pe-3">1</span>-->
              <!--                <a class="page-numbers pe-3" href="#">2</a>-->
              <!--                <a class="page-numbers pe-3" href="#">3</a>-->
              <!--                <a class="page-numbers pe-3" href="#">4</a>-->
              <!--                <a class="page-numbers" href="#">5</a>-->
              <!--                <a href="#" class="ps-3">-->
              <!--                  <svg class="bi" width="30" height="30"><use xlink:href="#long-arrow-alt-right"></use></svg>-->
              <!--                </a>-->
              <!--              </div>-->
              <!--            </nav>-->
            </main>

          </div>
        </div>
      </div>

    </div>


  </div>
</template>

<style scoped>
@import 'css/main.css';
.wenzi{
  font-size: 12px;
  .text{
    display: block;
  }
}
.mesBox{
  border-radius: 30px;
  width: 100%;
  padding: 30px;
  box-sizing: border-box;
  background-color: #f9f9fb;
  .title{
    margin-bottom: 30px;
    font-weight: bold;
  }
  .text{
    color: #7e7c7c;
  }
}
.status1{
  position: absolute;
  top: 10px;
  left: 30px;
  color: #fff;
  background-color: #727070;
  font-size: 12px;
  padding: 2px 10px;
  z-index: 99999999;
  border-radius: 5px;
}
.withoutBOX{

  width: 100%;
  display: flex;
  justify-content: center;
  flex-warp:warp;
  flex-direction: column;
  margin-top:-60px;
  padding-top: 0;
}
.heart{

  width: 1210px;
  margin: 0 auto;



}


.contentBox{
  display: flex;
  width: 1210px;

}
.headfont{
  width: 100%;
  margin-bottom: 40px;
  height: 103px;
  line-height: 103px;
  background: rgba(175, 177, 196, .08);
  font-size: 36px;
  font-weight: 400;
  color: #142133

}
</style>



// WEBPACK FOOTER //
// src/view/contact.vue